module.exports = __webpack_public_path__ + "static/media/orpheus_pro-medium.9a2b0a17.otf";